var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{attrs:{"data-testid":"elem_u_000001"}},[_c('Notification'),_c(this.$route.meta.layout,{tag:"component"},[_c('router-view',{key:_vm.$route.fullPath})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }